import React, { useState } from "react";
import ContentHeader from "../../components/Header";
import Sidebar from "../../components/Sidebar";
import ComingSoon from "../../components/ComingSoon";
import "./Expenses.css";
import ExpenseNavigation from "../../components/ExpensesComp/ExpenseNavigation";
import ExpenseContent from "../../components/ExpensesComp/ExpenseContent";

const Expenses = () => {
  const [isActive, setIsActive] = useState(false);

  return (
    <div className="col-md-12 content">
      <Sidebar
        className="sidebar-main"
        isActive={isActive}
        setIsActive={setIsActive}
        classNameTwo="open-sidebar"
      />
      <div className="col-12 sb-content">
        <div className="sb-content-header">
          <ContentHeader setIsActive={setIsActive} />
        </div>
        <div className="sb-nav">
          <ExpenseNavigation />
        </div>
        <div className="content-index">
          <ExpenseContent />
        </div>
      </div>
    </div>
  );
};

export default Expenses;
